module.exports = __webpack_public_path__ + "img/slide11.852f2a1f.png";